import { useState } from 'react';
import { useLang } from '../LangContext';
import galleryItems from '../data/galleryImages';

function GalleryItem({ item, onClick }) {
  if (item.type === 'video') {
    return (
      <div className="gallery-item gallery-item--video" onClick={() => onClick(item)}>
        <video src={item.src} muted playsInline preload="metadata" className="gallery-video-thumb" />
        <div className="gallery-overlay">
          <div className="play-btn">&#9654;</div>
        </div>
      </div>
    );
  }

  if (item.type === 'youtube') {
    return (
      <a
        className="gallery-item gallery-item--youtube"
        href={item.src}
        target="_blank"
        rel="noreferrer"
        aria-label={item.alt}
      >
        <div className="yt-card-bg">
          <svg className="yt-logo" viewBox="0 0 24 24" fill="none">
            <rect width="24" height="24" rx="6" fill="#FF0000" />
            <path d="M19.6 8.2a2 2 0 0 0-1.4-1.4C16.9 6.5 12 6.5 12 6.5s-4.9 0-6.2.3a2 2 0 0 0-1.4 1.4C4.1 9.5 4.1 12 4.1 12s0 2.5.3 3.8a2 2 0 0 0 1.4 1.4c1.3.3 6.2.3 6.2.3s4.9 0 6.2-.3a2 2 0 0 0 1.4-1.4c.3-1.3.3-3.8.3-3.8s0-2.5-.3-3.8z" fill="white" />
            <path d="M10.5 14.5v-5l4.5 2.5-4.5 2.5z" fill="#FF0000" />
          </svg>
          <div className="yt-card-text">
            <span className="yt-label">YouTube Videos</span>
            <span className="yt-sub">Let's watch &#9654;</span>
          </div>
        </div>
      </a>
    );
  }

  if (item.type === 'instagram') {
    return (
      <a
        className="gallery-item gallery-item--instagram"
        href={item.src}
        target="_blank"
        rel="noreferrer"
        aria-label={item.alt}
      >
        <div className="ig-card-bg">
          <svg className="ig-logo" viewBox="0 0 24 24" fill="none">
            <defs>
              <linearGradient id="ig-g2" x1="0%" y1="100%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#f09433" />
                <stop offset="50%" stopColor="#dc2743" />
                <stop offset="100%" stopColor="#bc1888" />
              </linearGradient>
            </defs>
            <rect width="24" height="24" rx="6" fill="url(#ig-g2)" />
            <path d="M12 7.2A4.8 4.8 0 1 0 12 16.8 4.8 4.8 0 0 0 12 7.2zm0 7.92A3.12 3.12 0 1 1 12 8.88a3.12 3.12 0 0 1 0 6.24z" fill="white" />
            <circle cx="17.04" cy="6.96" r="1.12" fill="white" />
          </svg>
          <div className="ig-card-text">
            <span className="ig-label">Instagram Reels</span>
            <span className="ig-sub">Let's watch &#9654;</span>
          </div>
        </div>
      </a>
    );
  }

  // default: image
  return (
    <div className="gallery-item" onClick={() => onClick(item)}>
      <img src={item.src} alt={item.alt} loading="lazy" />
      <div className="gallery-overlay">&#128269;</div>
    </div>
  );
}

function Lightbox({ item, onClose }) {
  if (!item) return null;
  return (
    <div className="lightbox" onClick={onClose}>
      <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
        <button className="lightbox-close" onClick={onClose}>&#10005;</button>
        {item.type === 'video' && (
          <video src={item.src} controls autoPlay className="lightbox-video" />
        )}
        {item.type === 'image' && (
          <img src={item.src} alt={item.alt} />
        )}
      </div>
    </div>
  );
}

export default function Gallery() {
  const [lightbox, setLightbox] = useState(null);
  const { t } = useLang();

  return (
    <section id="gallery" className="gallery">
      <span className="section-tag center">{t.galleryTag}</span>
      <h2 className="section-title">{t.galleryTitle}</h2>
      <p className="section-subtitle">{t.gallerySub}</p>

      <div className="gallery-grid">
        {galleryItems.map((item, i) => (
          <GalleryItem key={i} item={item} onClick={setLightbox} />
        ))}
      </div>

      <Lightbox item={lightbox} onClose={() => setLightbox(null)} />
    </section>
  );
}
